import { Amplify } from 'aws-amplify'
import * as React from 'react'
import { createRoot } from 'react-dom/client'

import App from './app'
import { awsConfig } from './config/env'
import { initSentry } from './config/sentry'
import './index.css'
import { enableMocking } from './test/mocks'

initSentry()

Amplify.configure(awsConfig)

const root = document.getElementById('root')
if (!root) throw new Error('No root element found')

enableMocking().then(() => {
  createRoot(root).render(<App />)
})

// Add React.StrictMode
